import React from 'react';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from "@mui/icons-material/Instagram";
import '../components-css/footer.scss'


const Footer = () => {
    const handleClickEvent = (value) => () => {
        if (value === 1) {
            window.open('http://www.instagram.com/milena_meliksetyan/')
        } else {
            window.open('https://m.facebook.com/milena.meliqsetyan.10')
        }
    }
    return (
        <div className={'footer-wrapper'}>
            <h4>Հետադարձ կապ</h4>
            <div className={'icon-wrapper'}>
                <InstagramIcon onClick={handleClickEvent(1)} sx={{color: "#bb003b"}}/>
                <FacebookIcon onClick={handleClickEvent(2)} sx={{color: "#1877F2"}}/>
            </div>
        </div>
    );
};

export default Footer;
